import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from '../shared/services/http.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TemplateKeyModalComponent } from './template-key-modal/template-key-modal.component';

@Component({
    selector: 'app-feedback-question',
    templateUrl: './feedback-question.component.html',
    styleUrls: ['./feedback-question.component.scss'],
    standalone: false
})
export class FeedbackQuestionComponent implements OnInit {

  dataSource: any
  filterDebounce = null
  displayedColumns = []
  scanning = false
  message = ''

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  columnNames = [
    {
      id: 'id',
      value: 'ID',
    },
    {
      id: 'likert',
      value: 'Likert'
    },
    {
      id: "question",
      value: "Question",
    },
    {
      id: "stmt",
      value: "Statement"
    },
    {
      id: "template_key",
      value: "Key"
    }
    ];

  constructor(private httpService: HttpService, private modalService: NgbModal) { }

  async openTemplateKeyModal(element: any){
    const modalRef = this.modalService.open(TemplateKeyModalComponent)
    modalRef.componentInstance.questionId = element.id
    modalRef.componentInstance.templateKeyId = element.key_id
    modalRef.componentInstance.label = element.label

    try {
      const result = await modalRef.result
      if( result ){
        await this.fetchQuestions()
      }
    } catch (e) {
      // modal dismissed
    }
  }

  filter( event ){

    if( this.filterDebounce ){
      window.clearTimeout( this.filterDebounce )
    }

    this.filterDebounce = window.setTimeout( () => {
      this.dataSource.filter = event.target.value.trim()
      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
    }, 250 )
  }

  async rescan( ){
    this.scanning = true
    this.message = 'Scanning trainings...'
    const resp:any = await this.httpService.postAsync('feedback/rescan', {})
    this.message = resp.added + ' questions added';
    if( resp.added > 0 ){
      await this.fetchQuestions()
    }
    window.setTimeout( () => {
      this.message = ''
      this.scanning = false

    }, 2500)
  }

  async fetchQuestions(){
    const questionsResponse: any = await this.httpService.getAsync('feedback/getQuestions')
    if( questionsResponse.success ){
      this.dataSource.data = questionsResponse.data
    }else{
      console.log(questionsResponse.message)
      alert("Failed to load questions")
    }
  }

  async ngOnInit() {

    this.dataSource = new MatTableDataSource([]);

    this.dataSource.filter = ''
    this.displayedColumns = this.columnNames.map(x => x.id);

    this.dataSource.paginator = this.paginator;

    this.fetchQuestions()
  }

}
